import { createApiRef } from '@backstage/core-plugin-api';

export interface JiraIssue {
  key: string;
  url: string;
  summary: string;
  type: string;
  typeIconUrl?: string;
  status: string;
  statusCategory: 'new' | 'indeterminate' | 'done' | string;
  assignee?: string;
  assigneeAvatarUrl?: string;
  /** Jira issue labels (field `labels`). */
  labels?: string[];
  updated: string;
}

export interface JiraApi {
  searchIssues(options: {
    jql: string;
    maxResults?: number;
  }): Promise<JiraIssue[]>;

  getBaseUrl(): Promise<string>;
}

export const jiraApiRef = createApiRef<JiraApi>({
  id: 'plugin.jira.service',
});
